import React from "react";

const AddButton = ({
  label,
  iconClass,
  buttonClass,
  onClick,
  disabled,
  fontSize,
}) => {
  const buttonStyle =
    fontSize === true ? { fontSize: "28px" } : fontSize ? { fontSize } : {};

  return (
    <button
      type="button"
      className={`btn ${buttonClass}`}
      onClick={onClick}
      {...(disabled && { disabled })}
    >
      <i className={iconClass} style={buttonStyle}></i> {label}
    </button>
  );
};

export default AddButton;
